<script lang="ts">
	import Guides from "luxedo-data/src/data/Guides"

	// This step is for a new device - has not been set up and is offline
</script>

<h1>Getting Started</h1>
<p>Congratulations on your new Luxedo! Let's get you set up.</p>
<p class="info">
	In order to communicate with your Luxedo device, it must be powered on and connected to Wi-Fi.
	Follow <a target="_blank" href={Guides.Device["Connecting to Wi-Fi"]}>this guide</a> to get your device
	connected.
</p>
<p class="help">
	Having trouble? Follow <a
		target="_blank"
		href={Guides["Device"]["Troubleshooting Connection To Wi-Fi"]}>this guide</a
	>
	for help troubleshooting. Or check out our
	<a target="_blank" href="https://luxhome.ai/pages/help">help center</a> for further assistance.
</p>

<style>
</style>
